<template>
    <div id="landing-banner-form">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                {
                    text: 'OSS Configs',
                    to: { path: '/landing-banners' },
                    exact: true,
                },
                {
                    text: 'Banner Landing Page',
                    to: { path: '/landing-banners' },
                    exact: true,
                },
                { text: $route.query.baru ? 'Tambah Banner' : 'Ubah Banner' },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">
            {{ $route.query.baru ? "Tambah" : "Ubah" }} Banner Landing Page
        </h3>

        <v-card style="border">
            <v-card-title> Detail Banner </v-card-title>
            <v-divider />
            <v-card flat class="d-flex">
                <v-col cols="3" class="py-0">
                    <v-card flat>
                        <v-card-text class="pa-0 my-2">
                            <v-card
                                flat
                                class="border-bottom-divider rounded-tl pa-0"
                            >
                                <a href="javascript:;">
                                    <img
                                        :src="
                                            url
                                                ? url
                                                : data.image && data.image != ''
                                                  ? data.image
                                                  : require('@/assets/img/unavailable.png')
                                        "
                                        :key="keyimg"
                                    />
                                </a>
                            </v-card>
                        </v-card-text>
                        <v-card-text class="pa-0 my-2">
                            <v-btn
                                @click="$refs.uploader.click()"
                                block
                                class="pa-0 font-weight-bold dark--text"
                                color="white"
                            >
                                Upload *
                            </v-btn>
                            <input
                                id="oss_config_landing_banner_image"
                                type="file"
                                ref="uploader"
                                class="d-none"
                                accept="image/*"
                                @change="onFileChange"
                            />
                        </v-card-text>
                        <v-card-text
                            class="text-caption pa-0 d-flex justify-center"
                        >
                            Rasio thumbnail foto 16:9
                        </v-card-text>
                        <v-card-text
                            class="text-caption pa-0 d-flex justify-center"
                        >
                            Maximum size is 200 KB
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="9" style="border-left: 1px solid #f0f0f0">
                    <v-card flat>
                        <v-card-text class="pa-0">
                            <v-list-item two-line>
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        ID *
                                    </v-list-item-title>

                                    <v-text-field
                                        id="oss_config_landing_banner_id"
                                        v-model="data.id"
                                        placeholder="ID"
                                        required
                                        outlined
                                        v-on:keypress="
                                            /\d/.test(
                                                String.fromCharCode(
                                                    $event.keyCode,
                                                ),
                                            )
                                                ? true
                                                : $event.preventDefault()
                                        "
                                        @change="
                                            data.id = data.id.replace(/\D/g, '')
                                        "
                                    />
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item two-line>
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        URL
                                    </v-list-item-title>

                                    <v-text-field
                                        id="oss_config_landing_banner_url"
                                        v-model="data.url"
                                        placeholder="Link"
                                        required
                                        outlined
                                    />
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item two-line>
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Type *
                                    </v-list-item-title>

                                    <v-select
                                        id="oss_config_landing_banner_type"
                                        placeholder="Pilih Jenis"
                                        v-model="data.type"
                                        outlined
                                        class="pa-0"
                                        :items="[
                                            { text: 'Link', value: 'link' },
                                            { text: 'Scroll', value: 'scroll' },
                                        ]"
                                    ></v-select>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item two-line>
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Status
                                    </v-list-item-title>
                                    <v-checkbox
                                        id="oss_config_landing_banner_status"
                                        label="Aktif"
                                        v-model="data.isActive"
                                        class="pa-0 ma-0"
                                        outlined
                                    />
                                </v-list-item-content>
                            </v-list-item>
                        </v-card-text>
                        <v-card-actions class="pa-4" v-if="data.type">
                            <v-spacer></v-spacer>
                            <v-btn
                                id="oss_config_landing_banner_simpan"
                                depressed
                                class="px-6 py-2 white--text"
                                color="blew"
                                @click="upload()"
                                >Simpan</v-btn
                            >
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-card>
        </v-card>
        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import _ from "lodash";
import AWS from "aws-sdk";
import { applyOssCredentials } from "@/modules/global/services/oss";
import Spinner from "@/components/plugins/Spinner";
import uniqid from "uniqid";

export default {
    name: "webapp-banner-form",

    components: {
        "app-spinner": Spinner,
    },

    data: function () {
        return {
            errors: [],
            isLoading: false,
            status: {
                PUBLISH: "PUBLISHED",
                UNPUBLISH: "UNPUBLISHED",
            },
            type: {
                SUBSCRIPTION: "SUBSCRIPTION",
                TICKET: "TICKET",
            },
            queryId: null,
            selectedPicture: null,
            infoids: this.$store.state.landingbanners.editInfoId,
            data: {},
            url: null,
            keyimg: 0,
            imageFile: null,
            tumbnail: null,
            tryouts: [],
        };
    },

    mounted: function () {
        this.data = this.$store.state.landingbanners.onEdit;
        if (!this.data) {
            this.$router.push("/landing-banners");
        }
    },

    destroyed() {
        this.$store.commit("landing_banners_clear");
    },

    methods: {
        onFileChange(e) {
            const file = e.target.files[0];

            if (file.size > 200000) {
                this.$store.commit("showAlert", {
                    message: `File lebih besar dari 200 KB!`,
                    type: "error",
                });
                return;
            }

            this.imageFile = file;
            this.keyimg++;
            this.url = URL.createObjectURL(file);
        },

        async upload(e) {
            this.isLoading = true;
            if (this.validateForm()) {
                var file = this.imageFile;
                if (this.data.image && !file) {
                    this.thumbnail = this.data.image;
                    this.save();
                } else {
                    if (!file) return;
                    if (file.type.indexOf("image") == -1) return;

                    try {
                        await applyOssCredentials(AWS);
                    } catch (error) {
                        this.$store.commit("showAlert", {
                            message: `Terjadi Kesalahan!`,
                            submessage: error.message,
                            type: "error",
                        });
                        this.isLoading = false;
                        return;
                    }

                    var spaceEndpoint = process.env.VUE_APP_OSS_END_POINT; // 'oss-ap-southeast-5.aliyuncs.com'
                    var bucket = new AWS.S3({
                        endpoint: spaceEndpoint,
                    });

                    var fileExt = file.name.substr(-4);
                    var filename = uniqid() + fileExt;
                    var params = {
                        Bucket: process.env.VUE_APP_OSS_BUCKET, // 'bonf-files',
                        Key: "landing_page/banners/" + file.name,
                        Body: file,
                        ContentType: file.type,
                        ACL: "public-read",
                    };

                    var context = this;
                    bucket.upload(params, function (error, data) {
                        if (error) {
                            context.$store.commit("showAlert", {
                                message: `Terjadi Kesalahan!`,
                                submessage: error,
                                type: "error",
                            });
                            context.isLoading = false;
                        } else {
                            context.thumbnail = data.Location;
                            context.save();
                        }
                    });
                }
            } else {
                this.isLoading = false;
            }
        },

        async save() {
            var context = this;
            var data = this.data;

            if (this.validateForm()) {
                context.isLoading = true;
                try {
                    var oldAss = this.$store.state.landingbanners.data;
                    const infos = this.$store.state.landingbanners.editInfoId;
                    var raws = this.$store.state.landingbanners.raw;

                    var newAss = oldAss.filter(
                        (e) => e.id != infos && e.id != this.data.id,
                    );
                    this.data.image = this.thumbnail;
                    newAss.push(this.data);

                    context.$store.commit("landing_banners_edited", newAss);
                    raws.hero.banners = _.orderBy(newAss, "id", "asc");
                    const parsed = JSON.stringify(raws);
                    const blob = new Blob([parsed], {
                        type: "application/json",
                    });

                    await this.$alioss.put("config/landing_page.json", blob);
                    context.$store.commit("showAlert", {
                        message: `Berhasil Update Data!`,
                        type: "success",
                    });

                    setTimeout(() => {
                        this.$router.push("/landing-banners");
                    }, 500);
                } catch (error) {
                    context.$store.commit("showAlert", {
                        message: `Terjadi Kesalahan!`,
                        submessage: error,
                        type: "error",
                    });
                    context.isLoading = false;
                }
            } else {
                this.isLoading = false;
                $(window).scrollTop(0);
            }
        },

        handleChangePicture: function (event) {
            const file = event.target.files[0];
            this.selectedPicture = file;
            this.data.picture = URL.createObjectURL(file);
        },

        validateForm() {
            var err = false;
            if (!this.data.type) {
                this.$store.commit("showAlert", {
                    message: `Tipe produk wajib diisi!`,
                    type: "error",
                });
                err = true;
                this.errors.push("Tipe produk wajib diisi");
            }

            if (!this.imageFile && !this.data.image) {
                this.$store.commit("showAlert", {
                    message: `Wajib upload gambar!`,
                    type: "error",
                });
                err = true;
            }

            if (!this.data.id) {
                this.$store.commit("showAlert", {
                    message: `ID wajib diisi!`,
                    type: "error",
                });
                err = true;
            }
            return !err;
        },

        characterCounter: function (text) {
            text = text.replace(/<[^>]*>/g, "");
            text = text.replace(/\&nbsp;/g, " ");
            return text.length;
        },
    },
};
</script>

<style>
.ck-content {
    min-height: 120px;
}
</style>



// WEBPACK FOOTER //
// Form.vue?700c9a08